import { render } from "./TransactionFactorModal.vue?vue&type=template&id=fd86ddb0"
import script from "./TransactionFactorModal.vue?vue&type=script&lang=js"
export * from "./TransactionFactorModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Company\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__